/**
 * 今日到店模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/report\/stores/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'stores': [{
      'id': 1,
      'name': '门店A'
    }, {
      'id': 9,
      'name': '门店B'
    }, {
      'id': 12,
      'name': '门店C'
    }, {
      'id': 13,
      'name': '门店D'
    }]
  },
  'message': 'ok'
})

Mock.mock(/report\/insurances_daily/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'count': 14,
    'entries': [{
      'date': '2016-11-20',
      'num_users_enquiry': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_prepaid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }, {
      'date': '2016-11-14',
      'num_users_enquiry': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_prepaid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }, {
      'date': '2016-11-13',
      'num_users_enquiry': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_prepaid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }],
    'page': 1,
    'total_count': 3
  },
  'message': 'ok'
})

Mock.mock(/report\/insurances_monthly/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'count': 7,
    'entries': [{
      'finish_rate': '0.00',
      'month': '2017-01',
      'num_users_due': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }, {
      'finish_rate': '0.00',
      'month': '2016-12',
      'num_users_due': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }, {
      'finish_rate': '0.00',
      'month': '2016-11',
      'num_users_due': 0,
      'num_users_finished': 0,
      'num_users_ordered': 0,
      'num_users_paid': 0,
      'num_users_quote': 0,
      'store_id': 1
    }],
    'page': 1,
    'total_count': 3
  },
  'message': 'ok'
})

Mock.mock(/coupon\/batches/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'count': 7,
    'entries': [{
      'coupon_batch_name': 'a',
      'status_display': '1',
      'num_issued': 0,
      'num_consumed': 0,
      'num_expired': 0,
      'usage_rate': '0.00%'
    }],
    'page': 1,
    'total_count': 3
  },
  'message': 'ok'
})
